'use client';

import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';
import { ComponentRef } from 'react';

import { cn } from '../../lib/utils';

interface SwitchProps extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
	size?: 'sm' | 'md';
	variant?: 'default' | 'shadowed';
}

const Switch = React.forwardRef<ComponentRef<typeof SwitchPrimitives.Root>, SwitchProps>(
	({ className, size = 'md', variant = 'default', ...props }, ref) => (
		<SwitchPrimitives.Root
			className={cn(
				'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input',
				{
					'h-4 w-8': size === 'sm',
					'shadow-sm': variant === 'shadowed'
				},
				className
			)}
			ref={ref}
			{...props}
		>
			<SwitchPrimitives.Thumb
				className={cn(
					'pointer-events-none block h-4 w-4 rounded-full bg-background ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0',
					{
						'h-3 w-3': size === 'sm',
						'shadow-lg': variant === 'shadowed'
					}
				)}
			/>
		</SwitchPrimitives.Root>
	)
);
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
